import { useTranslation } from 'react-i18next'

import { Button } from '#/shared/ui/button'
import { ChevronRightIcon } from '#/shared/ui/icons'

export function TrackingButton({ onClick }: { onClick?: () => void }) {
  const { t } = useTranslation()
  return (
    <Button
      type="button"
      variant="outline"
      size="xs"
      pressEffect
      onClick={onClick}
      className="w-full justify-between gap-1.25 px-2.5 text-gray-900 md:w-auto md:justify-center"
    >
      {t('detailToolbar.tracking')}
      <ChevronRightIcon className="size-2.5" />
    </Button>
  )
}
